import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { titelBild, titelPfad } from '../produktseite/Kopf';

// Handy-Kopf der Startseite (nur unter 861 px, siehe startseite.css): oben EIN großes Titelbild pro Werkzeug
// (dieselben Titelbilder wie im Shop, englische Fassung auf /en), das von selbst weiterwechselt und sich
// wischen lässt; darunter nur der Name und die Punkte.
// Davids Wunsch 15.10.2026: Studio Flow zuerst, dann Shake, Glitch, Bounce … und so clean und luftig wie
// der Kopf am PC: keine Kästen in Kästen, keine Preise und Texte unter dem Bild.
// Technik: waagerechte Scroll-Leiste mit Einrasten (Wischen ist dadurch echtes, flüssiges Scrollen).
// Hinten hängt eine Kopie des ersten Bilds; landet die Leiste dort, springt sie unsichtbar auf den Anfang.

const ZEIGEN_MS = 4500;      // so lange bleibt ein Bild stehen
const PAUSE_NACH_FINGER = 7000;
const LUECKE = 12;           // muss zu gap in .m-spur passen

// Studio Flow zuerst (gibt es nur im All-in-One, daher führt es dorthin), dann die Werkzeuge
const WERKZEUGE = [
  ['studio-flow', 'Studio Flow'], ['shake-flow', 'Shake Flow'], ['glitch-flow', 'Glitch Flow'], ['bounce-flow', 'Bounce Flow'],
  ['instant-grade', 'Instant Grade'], ['instant-comp', 'Instant Comp'], ['text-flow', 'Text Flow'], ['grid-flow', 'Grid Flow'],
];

function angebote(en) {
  const p = en ? '/en' : '';
  return WERKZEUGE.map(([slug, name]) => ({
    key: slug, name, bild: titelPfad(`/products/titel/${slug}.jpg`, en),
    to: slug === 'studio-flow' ? `${p}/shop/all-in-one` : `${p}/shop/${slug}`,
  }));
}

function Bild({ a, erstes, kopie }) {
  return (
    <Link className="m-angebot" to={a.to} aria-label={kopie ? undefined : a.name} aria-hidden={kopie || undefined} tabIndex={kopie ? -1 : undefined}>
      <img {...titelBild(a.bild, false, 'calc(100vw - 32px)')} alt="" loading={erstes ? undefined : 'lazy'} />
    </Link>
  );
}

export default function HandyAngebote({ en }) {
  const liste = angebote(en);
  const n = liste.length;
  const spur = useRef(null);
  const pauseBis = useRef(0);
  const [aktiv, setAktiv] = useState(0);

  useEffect(() => {
    const el = spur.current;
    if (!el || !matchMedia('(max-width: 860px)').matches) return undefined;
    const schritt = () => el.clientWidth + LUECKE;
    const index = () => Math.round(el.scrollLeft / schritt());
    let raf = 0, ende = 0, sichtbar = true;

    const beimScrollen = () => {
      if (!raf) raf = requestAnimationFrame(() => { raf = 0; setAktiv(index() % n); });
      clearTimeout(ende);
      // auf der Kopie des ersten Bilds angekommen: unsichtbar zurück an den Anfang
      ende = setTimeout(() => { if (index() >= n) el.scrollTo({ left: 0, behavior: 'auto' }); }, 140);
    };
    const anfassen = () => { pauseBis.current = Date.now() + PAUSE_NACH_FINGER; };
    const weiter = () => {
      if (!sichtbar || document.hidden || Date.now() < pauseBis.current) return;
      el.scrollTo({ left: (index() + 1) * schritt(), behavior: 'smooth' });
    };

    el.addEventListener('scroll', beimScrollen, { passive: true });
    el.addEventListener('touchstart', anfassen, { passive: true });
    el.addEventListener('pointerdown', anfassen);
    const io = new IntersectionObserver(([e]) => { sichtbar = e.isIntersecting; }, { threshold: 0.5 });
    io.observe(el);
    const takt = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : setInterval(weiter, ZEIGEN_MS);

    return () => {
      clearInterval(takt); clearTimeout(ende); cancelAnimationFrame(raf); io.disconnect();
      el.removeEventListener('scroll', beimScrollen);
      el.removeEventListener('touchstart', anfassen);
      el.removeEventListener('pointerdown', anfassen);
    };
  }, [n]);

  const springe = i => {
    const el = spur.current;
    pauseBis.current = Date.now() + PAUSE_NACH_FINGER;
    if (el) el.scrollTo({ left: i * (el.clientWidth + LUECKE), behavior: 'smooth' });
  };

  return (
    <div className="m-angebote">
      <div className="m-spur" ref={spur}>
        {liste.map((a, i) => <Bild key={a.key} a={a} erstes={i === 0} />)}
        <Bild a={liste[0]} kopie />
      </div>
      <div className="m-unter">
        <span className="m-name" aria-live="polite">{liste[aktiv].name}</span>
        <span className="m-punkte">
          {liste.map((a, i) => (
            <button key={a.key} type="button" aria-label={a.name} aria-current={i === aktiv || undefined}
              className={i === aktiv ? 'an' : ''} onClick={() => springe(i)} />
          ))}
        </span>
      </div>
    </div>
  );
}
